import React, { useState, useEffect} from "react";

import { makeStyles } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";
import DocuwareTemplateService from "../../../services/DocuwareTemplateService";
import ArrowBackIcon from '@material-ui/icons/ChevronLeft';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import RestoreFromTrashIcon from "@material-ui/icons/Restore";
import { Box, IconButton, Typography } from '@material-ui/core';
import { Table, TableHead, TableRow, TableCell, TableBody, Checkbox, TableSortLabel, FormControl, InputLabel, Select} from '@material-ui/core';
import { TablePagination } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { hasPrivilege } from "../../../utils/privileges_utility";

import RecycleBinModal from './../RecycleBinModal';
import notify from '../../../utils/notifier';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {
  Button
} from "@material-ui/core";



const userPrefs = {
    rowsPerPageOptions: [10, 25, 100]
};

const columns = [
    { id: 'id', label: 'Id',width: '20%', sortable: true},
    { id: 'name', label: 'Name',width: '20%', sortable: true },
    { id: 'deletedBy', label: 'Deleted By',width: '20%', sortable: true },
    { id: 'deletedAt', label: 'Deleted At',width: '20%', sortable: true },
    { id: 'client', label: 'Client',width: '10%' },
    { id: 'ownerClient', label: 'Owner Client',width: '10%' }
  ];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
        padding : '20px'
        },
        grid: {
        display: 'flex',
        overflow: 'auto'
        },

        tabContainer: {
        display: 'flex',
        alignItems: 'center',
        
        padding: 2,
        mb: 2 
        },

        backButton:{
        padding: 0,
        minWidth: 'auto',
        fontSize: '0.8rem',
        textTransform: 'none',
        fontFamily: 'PilatLight',
        marginBottom: '12px'
        },

        title:{
        fontFamily: 'PilatWideHeavy', 
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '32px'
        },

        tabColumn:{
        minWidth: 'auto',
        paddingX: 1,
        textTransform: 'none',
        fontSize: '0.9rem',
        fontWeight: '400',
        color: '#757575'
        },

        highlightedTabColumn:{
        minWidth: 'auto',
        paddingX: 1,
        textTransform: 'none',
        fontSize: '0.9rem',
        fontWeight: '700',
        color: '#000'
        },

        contentPage:{
        padding:'32px',
        backgroundColor: 'white',
        color:'black'
        },

        newFolderButton:{
        backgroundColor: '#00445D',
        borderRadius: '5rem',
        textTransform: 'none',
        color: '#fff', // text color
        '&:hover': {
            backgroundColor: '#0d1b5e',
        }
        },

        tabHeader:{
        '& .MuiTabs-indicator': {
            backgroundColor: '#000', 
            height: '4px'
        }
        },

    textField:{
        borderRadius: '10px',
        color: '#666',
        fontSize: '0.9rem',
        paddingTop : 2,
        paddingBottom : 2,
        height: '36px',
        width:'250px'
     },

    searchIcon:{
        fontSize: 20, color: '#888'
    },

    controlContainer:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    
  boldCell:{
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#00445D',
    textAlign: 'left',
    paddingTop: 0.5, paddingBottom: 0.5 
  },

  cell:{
    fontSize: '14px',
    color: '#1E1450',
    textAlign: 'left',
    paddingTop: 0.5, paddingBottom: 0.5 
  },

  whiteRow:{
    backgroundColor: '#fff',
    height:'30px'
  },

  coloredRow:{
    backgroundColor: '#F9FCFF',
    height:'30px'
  },

  table:{
    '& .MuiTableRow-root': {
        height: '40px',
    }
  },

  iconButton:{
    height: '22px',
    width:'22px',
    marginRight: '5px'
  },

  iconButtonIcon:{
    fontSize:'20px'
  },


  recycleBin: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    color: "#0E4B5B",
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#083446",
    },
    marginRight: '30px'
  },
  icon: {
    fontSize: 20,
    marginRight: 4,
  },
  label: {
    fontSize: '14px',
  },

  controlBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: 'space-between'
  },

  sortLabel: {
    color: "#00445D", // default color
    "&:hover": {
      color: "#0077b6", // hover color
    },
  },

  sortLabelActive: {
    fontWeight: "bold",   // bold active column
    color: "#005B96 !important", // highlight active column
  },

  sortIcon: {
    color: "#005B96 !important", // arrow color
  },

  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(0),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid #E0E0E0",
    backgroundColor: "white",
  },
  toggleGroup: {
    "& .MuiToggleButton-root": {
      border: "1px solid #E0E0E0",
      borderRadius: "20px !important",
      textTransform: "none",
      padding: theme.spacing(0.5, 2.5),
      color: "#333",
      fontWeight: 500,
      marginLeft:'5px',
      "&.Mui-selected": {
        backgroundColor: "#005B96",
        color: "#fff",
        fontWeight: "bold",
        border: "1px solid #005B96",
      }
    },
  },

  stickyActionCell: {
    position: "sticky",
    right: 0,
    background: "#fff", 
    zIndex: 2, 
    borderLeft: "1px solid #e0e0e0",
  },
  stickyHeaderCell: {
    position: "sticky",
    right: 0,
    background: "#f9f9f9",
    zIndex: 3,
  },

  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },

  boldCell:{
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#00445D',
    textAlign: 'left',
    paddingTop: 0.5, paddingBottom: 0.5 
  },

  cell:{
    fontSize: '14px',
    color: '#1E1450',
    textAlign: 'left',
    paddingTop: 0.5, paddingBottom: 0.5 
  },

  whiteRow:{
    backgroundColor: '#fff',
    height:'30px'
  },

  coloredRow:{
    backgroundColor: '#F9FCFF',
    height:'30px'
  },

  table:{
    '& .MuiTableRow-root': {
        height: '40px',
    }
  },

  iconButton:{
    height: '22px',
    width:'22px',
    marginRight: '5px',
    color: '#000'
  },

  actionButton:{
    height: '15px',
    width:'15px',
    marginRight: '2px',
    color: '#000'
  },

  iconButtonIcon:{
    fontSize:'20px'
  },

  controlContainer:{
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },

  checkBox:{
      padding: 0,             // remove extra padding
      verticalAlign: 'middle' // ensure alignment
    
  },

  title:{
    fontFamily: 'PilatWideHeavy', 
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '32px'
  },

  fieldName:{
    fontFamily: 'PilatWideHeavy', 
    textTransform: 'none',
    fontWeight: 'bold'
  },


}));

async function fetchTemplatesData(query){
    let output = {};
    
    const response = await DocuwareTemplateService.getRecycleDocuments(query);
    output.data = [];
    response.data.forEach(response => {
    output.data.push(response)
    })
    if (response.headers.hasOwnProperty('x-total-count')) {
        output['x-total-count'] = parseInt(response.headers['x-total-count']);
    }
    return output;
}



export default function RecycleBin({currentCompany}) {
  const classes = useStyles();
  const [circularBackdrop, setCircularBackdrop] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState(new Set());
  const [page, setPage] = useState(0);
  const [queryCount, setQueryCount] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const history = useHistory();
  const [searchText, setSearchText] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedActionRow, setSelectedActionRow] = useState(null);
  const [shareOpen, setShareOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [view, setView] = useState("all");
  const [anchorElTop, setAnchorElTop] = useState(null);
  const [bulkAnchorEl, setBulkAnchorElTop] = useState(null);
  const [disabledMenu, setDisabledMenu] = useState(true);
  const [type, setType] = useState("permanentDelete");

  const canDelete = hasPrivilege("DS_RECYC_DLT");
  const canPermanentDelete = hasPrivilege("DS_RECYC_PERM_DLT");


  const handleMultipleFileSelect = (id, checked) => {
    setSelectedDocuments(prev => {
        const newSet = new Set(prev); 
        if (checked) {
          newSet.add(id);
        } else {
          newSet.delete(id); 
        }
        return newSet;
      });   
  }

  const handleRequestSort = property => event => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
    setPage(0);
    fetchData(rowsPerPage, 0, property, isDesc ? "asc" : "desc");
  };

  const handleBulkMenuClick = (event) => {
    setBulkAnchorElTop(event.currentTarget);
  };

  const handleBulkMenuClose = () => {
    setBulkAnchorElTop(null);
  };

  const handleTopMenuClick = (event) => {
    setAnchorElTop(event.currentTarget);
  };

  const handleTopMenuClose = () => {
    setAnchorElTop(null);
  };

  const handleShareClick = () => {
    setShareOpen(true);
    handleMenuClose();

  };

  const refreshPage = () => {
    fetchData(rowsPerPage,0, orderBy, order);
  }

  const handleDeleteClick = () => {
    setDeleteOpen(true);
    setType('permanentDelete');
    handleMenuClose();
    handleBulkMenuClose();
  };

  const handleRestoreClick = () => {
    setDeleteOpen(true);
    setType('restore');
    handleMenuClose();
    handleBulkMenuClose();
  };

  const handleEmptyClick = () => {
    setDeleteOpen(true);
    setType('empty');
    handleMenuClose();
    handleBulkMenuClose();
  };

  const handleHomeClick = () => {
    history.push('/document-suite');
  };

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
      setAnchorEl(event.currentTarget);
      setSelectedActionRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedActionRow(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData(rowsPerPage, newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    fetchData(+event.target.value, 0);
  };

  const fetchData = async (
    pageSize = rowsPerPage,
    currentPage = 0,
    sortBy = orderBy,
    sortOrder = order
  ) => {
    setCircularBackdrop(true);
    let query = {
      _page: currentPage + 1,
      _limit: pageSize,
    };

    if (sortBy && sortOrder){
      query['_sort'] = sortBy;
      query['_order'] = sortOrder;
    }
 
    fetchTemplatesData(query)
      .then(response => {
        let _data = response.data;
        setRows(_data);
        if (response.hasOwnProperty('x-total-count')) {
          setQueryCount(parseInt(response['x-total-count']));
        }
        setCircularBackdrop(false);
      })
      .catch(error => {

        setCircularBackdrop(false);
        notify({
          type: 'error',
          message: 'Internal Server Error'
        });
        setRows(null);
      });
  };

  const createNoTable = () => {
    let arr = [];
    arr.push(
      <TableRow style={{ height: '60px' }}>
        <TableCell colSpan="11" align="center" className={classes.noRecordsRow}>
          {circularBackdrop ? 'Fetching data, please wait' : 'No records found'}
        </TableCell>
      </TableRow>
    );
    return arr;
  };

  useEffect(() => {
    fetchData(rowsPerPage, page);
  }, [currentCompany]);



  return (
    <div className={classes.root}>
    <div style={{marginBottom: '20px'}}>
      <div sx={{ padding: '1rem 0' }}>
        <Button
          onClick={handleHomeClick}
          startIcon={<ArrowBackIcon />}
          className={classes.backButton}
        >
        Back to Documents
        </Button>
        <Box className={classes.controlBox}>
          <Typography 
            variant="h4" 
            className={classes.title}
          >
            RECYCLE BIN
          </Typography>
          <Box className={classes.recycleBin} onClick={handleEmptyClick}>
              <DeleteOutlineIcon className={classes.icon} />
              <Typography className={classes.label}><b>Empty Recycle Bin</b></Typography>
           </Box>
        </Box>
       
      </div>
    </div>
    <div className={classes.contentPage}>

    <div className={classes.tableWrapper}>
      <Box className={classes.headerContainer}>
        <Box>     </Box>
        <Box className={classes.controlContainer}>
          {selectedDocuments && selectedDocuments.size >= 1 ? (
              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="body2" style={{ fontWeight: 500 }}>
                  {selectedDocuments.size} Items Selected
                </Typography>

                <Button
                  variant="contained"
                  style={{
                    borderRadius: "999px",
                    backgroundColor: "#e0f0f7",
                    color: "#1E1450",
                    fontWeight: 600,
                    textTransform: "none",
                    marginLeft: '5px'
                  }}
                  endIcon={<span style={{ fontSize: "16px" }}>▾</span>}
                  onClick={handleBulkMenuClick}
                >
                  Bulk Actions
                </Button>

                <Menu
                  anchorEl={bulkAnchorEl}
                  keepMounted
                  open={Boolean(bulkAnchorEl)}
                  onClose={handleBulkMenuClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem onClick={handleRestoreClick}>
                    <RestoreFromTrashIcon style={{ marginRight: 8 }}  fontSize="small" />
                    Restore
                  </MenuItem>
                  {canPermanentDelete ? <MenuItem onClick={handleDeleteClick}>
                    <DeleteIcon style={{ marginRight: 8 }}  fontSize="small" />
                    Delete
                  </MenuItem> : null }
                </Menu>
              </Box>
            ) : (
              <IconButton
                className={classes.iconButton}
                onClick={handleTopMenuClick}
              >
                  <MoreVertIcon sx={{ color: "#005B96" }} />
              </IconButton>
            )}



        </Box>
      </Box>
      <div style={{ width: '100%', overflowX: 'auto' }}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow className={classes.whiteRow}>
            <TableCell />
            {columns.map(column => { 
              return (
                <TableCell 
                  className={classes.boldCell}
                  key={column.id}
                  sortDirection={orderBy === column.id ? order : false}
                >
                  {column.sortable ? (
                  <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={handleRequestSort(column.id)}
                      hideSortIcon={false}
                      classes={{
                        root: classes.sortLabel,
                        active: classes.sortLabelActive,
                        icon: classes.sortIcon,
                      }}
                  >
                      {column.label}
                      {orderBy === column.id ? (
                      <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </span>
                      ) : null}
                  </TableSortLabel>
                  ) : (
                    column.label
                  )}
                </TableCell>);
              
            })}
            <TableCell className={`${classes.boldCell} ${classes.stickyHeaderCell}`} align="right">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows && rows.length
            ? rows.map((row, index) => {
                return (
                  <TableRow hover role="data-row" key={index} className={index%2==0 ? classes.coloredRow :classes.whiteRow}>
                    <TableCell>
                      {/* <Checkbox /> */}
                      <Checkbox
                        size="small"
                        className={classes.checkBox}
                        checked={selectedDocuments.has(row.id)} 
                        onChange={(event)=>{
                          const isChecked = event.target.checked;
                          return handleMultipleFileSelect(row.id, isChecked);
                        }}
                      />
                    </TableCell>
                    {columns.map(column => {
                        let value = row[column.id];
                        if(typeof value == 'boolean'){
                          if(value){
                            value = 'true'
                          }else{
                            value = 'false'
                          }
                        }
                        return (
                          <TableCell className={classes.cell} key={column.id} align={column.align} width={column.width}>
                            {value || '-'}
                          </TableCell>
                        );
                    })}
  
                    <TableCell align="center" className={classes.stickyActionCell}>
                      <IconButton
                        className={classes.iconButton}
                        onClick={(e) => handleMenuClick(e, row)}
                        disabled={selectedDocuments && selectedDocuments.size >= 1}
                      >
                        <MoreVertIcon sx={{ color: "#005B96" }} />
                      </IconButton>
                    </TableCell>

                  </TableRow>
                );
              })
            : createNoTable()}
        </TableBody>
      </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={userPrefs.rowsPerPageOptions}
        component="div"
        count={queryCount}
        page={page}
        onChangePage={handleChangePage}
        rowsPerPage={rowsPerPage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        backIconButtonProps={{
          'aria-label': 'previous page'
        }}
        nextIconButtonProps={{
          'aria-label': 'next page'
        }}
        labelRowsPerPage={'Rows per page'}
      />

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",  
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",      
          horizontal: "right",
        }}
        getContentAnchorEl={null}
        disabled = {selectedDocuments && selectedDocuments.size >= 1 }
      >
        <MenuItem onClick={handleRestoreClick}>
          <RestoreFromTrashIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
          Restore
        </MenuItem>
        {canPermanentDelete ? <MenuItem onClick={handleDeleteClick}>
          <DeleteIcon className={classes.actionButton} fontSize="small" style={{ marginRight: 8 }} />
          Delete
        </MenuItem> :null}
      </Menu>

      <Menu
        anchorEl={anchorElTop}
        keepMounted
        open={Boolean(anchorElTop)}
        onClose={handleTopMenuClose}
        anchorOrigin={{
          vertical: "bottom",   
          horizontal: "right", 
        }}
        transformOrigin={{
          vertical: "top",    
          horizontal: "right",
        }}
        getContentAnchorEl={null}
      >
      </Menu>


    <RecycleBinModal
      open={deleteOpen}
      onClose={() => setDeleteOpen(false)}
      document={selectedActionRow}            // single delete OR
      fileIdentifiers={selectedDocuments ? Array.from(selectedDocuments) : []}  // bulk delete
      loading={false}
      type={type}
      count={queryCount}
      handleRefresh = {refreshPage}
    />


    </div>

    </div>
    </div>
  );
}
